import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => window.gtag && window.gtag("event", "whatsapp_click", { location: "floating_button" })}
      data-testid="whatsapp-chat-button"
      aria-label="Chat with an Antigua specialist on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-3"
    >
      <span className="pointer-events-none hidden translate-x-2 rounded-full border border-gold/25 bg-navy-deep/90 px-4 py-2 text-xs font-medium text-ivory opacity-0 backdrop-blur-md transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100 sm:block">
        Chat with an Antigua specialist
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/30 transition-transform duration-300 group-hover:scale-105">
        <span className="absolute inset-0 rounded-full bg-[#25D366]/60 animate-pulse-ring" />
        <MessageCircle className="relative h-6 w-6 text-white" />
      </span>
    </a>
  );
}
